module.exports = __webpack_public_path__ + "img/1.1c4c6f30.jpg";